import { IMessageHandler } from "../message-handler";
import { IHandlerContext } from "../handler-context";
import { StorageMessage, StorageResponse } from "../../crypto/crypto-types";

interface SavePortfolioRequest {
  userId: string;
  portfolioData: any;
  password: string;
}

interface SavePortfolioResponse {
  success: boolean;
}

export class SavePortfolioHandler implements IMessageHandler<SavePortfolioRequest> {
  constructor(private context: IHandlerContext) {}

  canHandle(type: string): boolean {
    return type === "SAVE_PORTFOLIO";
  }

  async handle(message: StorageMessage<SavePortfolioRequest>, source: Window, origin: string): Promise<void> {
    const { userId, portfolioData, password } = message.data;

    if (!userId || !portfolioData || !password) {
      this.context.sendError(source, 'Missing required data', 'MISSING_DATA', origin, message.requestId);
      return;
    }

    // Get user and authenticate
    const userProfile = await this.context.dbService.getUserById(userId);
    if (!userProfile) {
      this.context.sendError(source, 'User not found', 'USER_NOT_FOUND', origin, message.requestId);
      return;
    }

    const sessionKey = await this.context.cryptoEngine.authenticateUser(userProfile, password);
    const encryptedData = await this.context.cryptoEngine.encryptPortfolioData(portfolioData, sessionKey, userId);
    
    await this.context.dbService.storePortfolio(encryptedData);

    const response: StorageResponse<SavePortfolioResponse> = {
      type: 'RESPONSE',
      data: { success: true },
      requestId: message.requestId
    };
    this.context.sendResponse(source, response, origin, message.requestId);
  }
}
